<template>
    <div>
        <!-- mojilogo 下载 -->
        <div class="download">
            <div class="mojilogo">
                <!-- logo -->
                <div class="logodian">
                    <span
                        class="dian"
                        v-if="v.isnew"
                    ></span>
                    <img
                        :src="icon"
                        :class="type=='home'?'logo1':'logo2'"
                    />
                </div>
                <!-- 文本 -->
                <div class="text">
                    <div>
                        <span class="v">{{v.appType==2?'Android':'IPhone'}} v</span>
                        <span class="v1">{{v.appVersion}}</span>
                    </div>
                    <div>{{v.appCreated.split(" ")[1]}}</div>
                </div>
            </div>
            <!-- 下载 -->
            <div class="downall">
                <div
                    @click="download(v.appKey,v.id,v.appType)"
                    class="down"
                >
                    <img :src="v.appType==2?require('../assets/img/anzhuo@3x.png'):require('../assets/img/anzhuo1@3x.png')"> 下载
                </div>
                <img
                    :src="showflag==i?require('../assets/img/返回2@3x.png'):require('../assets/img/返回3@3x.png')"
                    @click="show(v,i)"
                    v-if="type=='detail'&&v.appName!='墨迹天气IPC'&&v.appDesc.length>0"
                    class="shangxia"
                />
            </div>

        </div>

        <!-- 版本详情  -->
        <div class="detail">
            <!-- 点击弹出下面 分为两种:大于2条和小于2条的 -->
            <div
                class="top"
                v-if="v.appDesc.length>=2&&type=='home'"
            >
                <div>
                    <p :style="{color:v.appDesc[0]&&v.appDesc[0].split('[').length>1?'black':''}">{{v.appDesc[0]?v.appDesc[0].split(":")[0]:''}}:
                        <span>{{v.appDesc[0]?v.appDesc[0].split(":")[1]:''}}</span>
                    </p>
                    <p :style="{color:v.appDesc[1]&&v.appDesc[1].split('[').length>1?'black':''}">{{v.appDesc[1]?v.appDesc[1].split(":")[0]:''}}:
                        <span>{{v.appDesc[1]?v.appDesc[1].split(":")[1]:''}}</span>
                    </p>
                </div>
                <img
                    class="shangxia"
                    :src="showflag==i?require('../assets/img/返回2@3x.png'):require('../assets/img/返回3@3x.png')"
                    @click="show(v,i)"
                />
            </div>
            <div
                class="top"
                v-if="v.appDesc.length<2&&v.appDesc.length>0&&type=='home'"
            >
                <div>
                    <p>{{v.appDesc[0]?v.appDesc[0]:''}}</p>
                    <p>{{v.appDesc[1]?v.appDesc[1]:''}}</p>
                </div>
            </div>

            <!-- 详情 -->
            <div
                class="info"
                v-if="showflag==i"
                :style="{paddingBottom:type=='home'?'0':'.2rem'}"
            >
                <p
                    v-for="(val,ind) in v.appDesc"
                    :key="ind"
                    v-if="type=='home'?ind!=1&&ind!=0:1"
                    :class="val.indexOf('[')?'zi':'tou'"
                >
                    <span v-if="ind!=0&&ind!=1">{{val}}</span>
                    <!-- 让前两行的版本号变色 -->
                    <span
                        v-else
                        class="onetwo"
                    >
                        {{val.split(':')[0]}}:
                        <b>{{val.split(':')[1]}}</b>
                    </span>
                </p>

            </div>
        </div>

    </div>
</template>
<script>
export default {
    props: ["v", "i", "type"],
    data() {
        return {
            showflag: null,
            icon: require("../assets/img/logo.png")
        };
    },
    mounted() {
        var appIdentifierarr = [
            "com.moji.MojiWeatherTest",
            "com.moji.MojiWeather",
            "com.moji.mjweather.alpha7",
            "com.moji.mjweather",
            "com.moji.mjweather.alpha",
            "com.moji.MojiWeatherNew",
            "com.moji.dailybuild"
        ];
        appIdentifierarr.forEach((v, i) => {
            if (v == this.v.appIdentifier) {
                this.icon = require("../assets/img/" + v + ".png");
            }
        });
        if (this.v.appName == "日拱一卒") {
            this.icon = require("../assets/img/logo_bing.png");
        }
    },
    methods: {
        //跳转下载地址
        download(key, id, type) {
            // 保存历史
            var arr = [];
            if (localStorage.getItem("clickItem")) {
                arr = localStorage.getItem("clickItem").split(",");
            }
            if (arr.indexOf(id) === -1) {
                arr.push(id);
            }
            localStorage.setItem("clickItem", arr.join(","));
            //跳转,判断是否是在本地运行
            if (location.hash) {
                this.$router.push({
                    path: "/xiazai",
                    query: {
                        appkey: key,
                        type
                    }
                });
            } else {
                var html = this.type + ".html";
                var url =
                    location.href.split(html)[0] +
                    `xiazai.html?appkey=${key}&type=${type}`;
                location.href = url;
            }
        },
        //详情显示与隐藏
        show(v, i) {
            if (this.showflag == null) {
                this.showflag = i;
            } else {
                this.showflag = null;
            }
        }
    }
};
</script>

<style lang='scss' scoped>
.download {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 0.2rem;

    .logo1 {
        width: 0.5rem;
        height: 0.5rem;
        border-radius: 0.05rem;
    }
    .logo2 {
        width: 0.36rem;
        height: 0.36rem;
        border-radius: 0.03rem;
    }
    .logodian {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        .dian {
            position: absolute;
            width: 0.12rem;
            height: 0.12rem;
            background: red;
            border-radius: 50%;
            right: -0.035rem;
            top: -0.035rem;
        }
    }
    .down {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.16rem;
        color: #4294ea;
        border: 0.01rem solid #4294ea;
        padding: 0.01rem 0.115rem;
        border-radius: 0.05rem;
        img {
            width: 0.14rem;
            height: 0.17rem;
            margin-right: 0.05rem;
        }
    }
    .downall {
        display: flex;
        justify-content: center;
        align-items: center;
        .shangxia {
            width: 0.16rem;
            padding: 0.15rem 0.16rem 0.15rem 0.16rem;
            margin-right: -0.16rem;
        }
    }

    .mojilogo {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 0.2rem;
        padding-bottom: 0.2rem;
        .text {
            margin-left: 0.1rem;
            .v,
            .v1 {
                font-size: 0.16rem;
            }
            > div:last-child {
                font-size: 0.12rem;
                color: #999999;
            }
        }
    }
}
.detail {
    .top {
        border-top: 0.01rem dashed #e5e5e5;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 0.2rem;
        p {
            color: #999999;
            font-size: 0.12rem;
            padding: 0.0125rem 0;
            span {
                color: #323232;
            }
        }
        img {
            width: 0.16rem;
            padding: 0.15rem;
            margin-right: -0.15rem;
        }
    }
}
.info {
    p {
        b {
            color: #323232;
            font-weight: normal;
        }
    }
    .tou {
        color: #323232;
        font-size: 0.12rem;
        padding: 0.07rem 0 0.03rem;
    }
    .zi {
        color: #999999;
        font-size: 0.12rem;
        padding: 0.0125rem 0;
    }
}
</style>
